module.exports = __webpack_public_path__ + "static/media/11.4721a8b1.jpeg";